import InternalLink from "./InternalLink";

export default InternalLink;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/Navigation/InternalLink/index.tsx